<template lang="pug">

  v-card.table-filters

    // Save Dialogue
    v-dialog(v-model="isSavingFirstTime" persistent width='480px')
      v-card
        title-bar(dark) Name your filter
        v-card-text
          v-text-field(
            label="Filter Name"
            v-model="filterName"
            placeholder="Enter a filter name"
          )
        v-card-actions
          v-spacer
          v-btn(
            flat
            @click="clickedCancelSave"
          ) Cancel
          v-btn.primary(
            @click="saveFilter"
            :disabled="!filterName.trim().length"
          ) Save

    // Rename Dialogue
    v-dialog(v-model="isRenaming" persistent width='480px')
      v-card
        title-bar(dark) Rename your filter
        v-card-text
          v-text-field(
            label="Filter Name"
            v-model="filterName"
          )
        v-card-actions
          v-spacer
          v-btn(
            flat
            @click="clickedCancelRename"
          ) Cancel
          v-btn.primary(
            @click="saveFilter"
            :disabled="!filterName.trim().length"
          ) Update

    //Save as static list Dialogue
    v-snackbar(:value="isStaticListCreated" color="success")
      div Static List Created
    v-dialog(v-model="isSavingAsStaticList" persistent width='480px')
      v-card
        title-bar(dark) Name your static list
        v-card-text
          v-text-field(
            label="Static list name"
            v-model="staticListName"
            placeholder="Enter a static list name"
          )
        v-card-actions
          v-spacer
          v-btn(
            flat
            @click="clickedCancelStaticListCreation"
          ) Cancel
          v-btn.primary(
            @click="createStaticListWithFilteredContacts"
            :disabled="!staticListName.trim().length"
          ) Save

    liondesk-dialog(
      dialogTitle="Are you sure? "
      :dialogBody="deleteFilterModalText"
      okButtonText="Delete"
      v-model="isDeleting"
      @click:cancel="isDeleting = false"
      @click:ok="deleteFilter"
    )

    v-card-title.saved-filters
      v-select(
        :items="userFilters"
        item-text="name"
        item-value="id"
        label='Saved Filter'
        v-model="currentFilter"
        @change="changeSelect"
        return-object
        prepend-icon="filter_list"
      )
        template(slot="item" slot-scope="{ item }")
          v-layout(v-if="!item.isLoadMore") {{ item.name }}
            v-icon.facebook-logo(v-if="item.fb_user_type_id" color="primary" right) {{ getIcon(item.fb_user_type_id) }}
          v-layout(v-else)
            a(@click="item.callback()" class="load-more-button")
              v-icon(color="primary") control_point
              |  Load more ...

      v-card-text.errors(v-if="hasContactFilterFindErrors") {{ contactFilterFindErrors }}

    template
      v-card-text(v-if="showConditions")
        v-layout.column(
          v-for='(activeConditionsGroup, index) in activeConditions'
          :key='generateGroupKey(index, activeConditionsGroup)'
        )
          v-layout.row
            v-flex.condition-group-operator.xs12.my-1(v-if="index >= 1 && activeConditionsGroup.length > 0" tag="h5") {{ activeConditionsGroup[0].groupConditionType }}
          v-layout.row
            v-flex.grow.py-1.condition-group
              div(
                v-for='(condition, subqueryIndex) in activeConditionsGroup'
                :key='generateKey(index, subqueryIndex, condition)'
                v-if="queryType(condition) !== 'keywords'"
              )
                v-divider.condition-divider.mx-3.my-2(v-if="condition.conditionType === OR_CONDITION")
                condition(
                  :index="index"
                  :subquery-index="subqueryIndex"
                  :available-filter-fields="availableFilterFields"
                  :condition="condition"
                  :conditions-length="activeConditionsGroup.length"
                  @input="updateCondition"
                  @add-condition="addNewActiveCondition"
                  @delete="removeItem"
                )
            v-flex.shrink
              v-btn.filter__action(flat icon @click="removeGroup(index)")
                v-icon(color="red") cancel

      v-list-tile.pb-2(v-if="activeConditions.length == 0")
        v-btn(
          class="add-condition-ff"
          color='primary'
          flat
          @click="addNewConditionGroup('')"
        )
          v-icon add
          | Add Condition

      v-list-tile.pb-2(v-if="activeConditions[0] && activeConditions[0].length > 1")
        v-btn(
          class="add-condition-ff"
          color='primary'
          outline
          @click="addNewConditionGroup(AND_CONDITION)"
        )
          | And
        v-btn(
          class="add-condition-ff"
          color='primary'
          outline
          @click="addNewConditionGroup(OR_CONDITION)"
        )
          | Or

    div.errors(v-show="hasContactFilterSaveErrors") {{ contactFilterSaveErrors.join(',') }}

    v-card-actions
      v-layout
        v-flex(shrink)
          div(v-if="!activeConditions.length && !isEmailList")
            strong To filter your contacts:&nbsp;
            span select a Saved Filter from the dropdown or click "+ Add Condition" to build a new one.
          v-btn(
            @click='applyFilter'
            color='primary'
            :loading="isLoading"
            :disabled="!isDirty || isLoading"
            v-if="activeConditions.length && showConditions") Apply Filter
          v-btn(v-if="activeConditions.length || isEmailList" @click='clearFilters' color='primary' flat) Reset
          v-menu(v-if="activeConditions.length || isEmailList" offset-y)
            v-btn(slot="activator"
            flat
            color="primary") Manage Filter
            v-list
              v-list-tile.px-4(v-if="showConditions && !isNew")
                strong Current filter:&nbsp;
                span {{ this.selectedFilter.name }}
              v-list-tile(v-if="showConditions")
                v-btn.min-width-btn(
                  flat
                  color="primary"
                  :disabled="!isDirty"
                  @click="clickedSave") Save
              v-list-tile.background-transparent(v-if="showConditions" @click.stop="")
                v-menu(right offset-x :close-on-content-click="false" max-width="400" nudge-right="24")
                  v-btn(
                    slot="activator"
                    color='primary'
                    flat
                  ) Dashboard Options&nbsp;
                    v-icon chevron_right
                  dashboard-filter-options(:active-conditions="activeConditions")
              v-list-tile(v-if="!isNew && showConditions")
                v-btn(
                  @click='clickedRenameFilter'
                  color='primary' 
                  flat) Rename
              v-list-tile(v-if="!isNew && (showConditions || isEmailList)")
                v-btn(
                  @click='isDeleting = true'
                  color='error'
                  flat) Delete
              v-divider(v-if="showConditions")
              v-list-tile(v-if="showConditions")
                v-btn(
                  @click='clickedSaveAsStaticList'
                  color='primary' flat
                  :disabled="!activeConditions.length > 0")
                    v-icon save_alt
                    span &nbsp;Save as Static List
              v-list-tile(v-if="false")
                v-btn(
                  :disabled="hasCustomAudience"
                  @click='showCreateCustomAudience()'
                  color='primary' flat)
                  span Sync FB Custom Audience
                  v-tooltip(bottom)
                    span Custom audiences synced from LionDesk will be named: "LionDesk - {static list name}"
                    v-icon.ml-2.icon-align(slot="activator") info
        v-flex(shrink)
          v-progress-circular(
            v-if="areContactFiltersSaving"
            :size='20'
            :width='2'
            color='primary'
            indeterminate
          )
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';

import Modal from '@/Core/mixins/modal';
import TitleBar from '@/Core/components/TitleBar';
import LiondeskDialog from '@/Core/components/LiondeskDialog';
import Condition from './Condition';
import DashboardFilterOptions from './DashboardFilterOptions';
import { AND_CONDITION, OR_CONDITION } from '../../utilities/filter-query-builders/constants';

const defaultFilterName = '';

export default {
  components: { Condition, LiondeskDialog, TitleBar, DashboardFilterOptions },

  mixins: [Modal],

  props: {
    /**
     * ** this.activeConditions **
     *
     * [this.value] == [v-model=selectedConditions] from parent
     *
     * Not sure why we don't make this a named prop.
     * At mount time, we rename this.value to this.activeConditions
     *
     * activeConditions are conditions currently listed in the interface.
     *
     * @type {Array}
     */
    value: {
      type: Array,
      default: () => [],
    },

    searchTerm: {
      type: String,
      default: '',
    },

    /**
     * All the conditions available for selection.
     * Consisting of objects of this form:
     * [{
     *    name: 'Hotness',
     *    field: 'hotness_id',
     *    type: 'foreignKey',
     *    icon: 'list',
     *  }, ...
     * ]
     *
     * @type {Array}
     */
    availableFilterFields: {
      type: Array,
      default: () => [],
    },

    /**
     * All the saved filters the user has saved
     *
     * @type {Object}
     */
    savedFilters: {
      type: Array,
      default: () => [],
    },
    hasMoreSavedFiltersToLoad: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      /**
       * On load, don't show filter conditions.
       * To show:
       * - saved filter is selected
       * - New Filter button is clicked
       *
       * @type {Boolean}
       */
      filterName: defaultFilterName,
      staticListName: '',
      activeConditions: [], // this.value
      isSavingFirstTime: false,
      isRenaming: false,
      isDeleting: false,
      isSavingAsStaticList: false,
      isStaticListCreated: false,
      currentFilter: {},
      // The key for condition rows uses the resetNumber,
      // ensuring a full clear of all rows on reset.
      // Otherwise, conditions or values may linger after resetting.
      resetNumber: 0,
      deletions: 0,
      groupDeletions: 0,
      showConditions: true,
      createCustomAudience: false,
      AND_CONDITION,
      OR_CONDITION,
    };
  },
  created() {
    //if a filter is selected from the dashboard, this will preload the component
    //with the filter's info and conditions
    if (this.selectedFilter) this.currentFilter = this.selectedFilter;
    this.findTeamMembers();
  },
  mounted() {
    this.activeConditions = this.value;
    if (!this.filterName) {
      this.filterName = defaultFilterName;
    }

    // If the selected filter is empty, clear it
    this.$watch(
      'selectedFilter',
      selectedFilter => {
        if (!Object.keys(selectedFilter).length) {
          this.clearFilters();
        }
      },
      { deep: true },
    );

    /**
     * this.value (aka activeConditions) may be updated when
     * the options for one of the available filter fields has changed.
     *
     * When this happens, we update the value of activeConditions to match
     */
    this.$watch(
      'value',
      value => {
        this.activeConditions = value;
      },
      { deep: true },
    );

    this.$watch(
      'searchTerm',
      searchTerm => {
        this.updateSearchCondition(searchTerm);
      },
      { deep: true },
    );
  },
  computed: {
    ...mapState({
      isDirty: state => state.contactFilters.isDirty,
      selectedFilter: state => state.contactFilters.selectedFilter,
      areContactFiltersSaving: state => state.contactFilters.isSaving,
      contactFilterSaveErrors: state => state.contactFilters.saveErrors,
      contactFilterFindErrors: state => state.contactFilters.findErrors,
      isDisplayedOnDashboard: state => state.contactFilters.isDisplayedOnDashboard,
      emailLists: state => state.contactsTable.emailLists,
      selectedEmailListId: state => state.contactsTable.selectedEmailListId,
      hasMoreEmailListsToLoad: state => state.contactsTable.hasMoreEmailListsToLoad,
      isLoading: state => state.contactsTable.isLoading,
    }),
    ...mapGetters({
      hasContactFilterSaveErrors: 'contactFilters/hasSaveErrors',
      hasContactFilterFindErrors: 'contactFilters/hasFindErrors',
      hasEmaillists: 'contactsTable/hasEmaillists',
      userHasDeleteStaticList: 'userInformation/userHasDeleteStaticList',
      userHasFeatureFlag: 'userInformation/userHasFeatureFlag',
    }),
    isNew() {
      return !this.currentFilter || !this.currentFilter.id;
    },
    userFilters() {
      var filters = [
        ...this.savedFilters,
      ];

      if (this.hasMoreSavedFiltersToLoad) {
        filters = [
          ...filters,
          ...[{ isLoadMore: true, disabled: true, callback: this.loadMoreSavedFilters }],
        ];
      }

      if (this.hasEmaillists) {
        filters = [
          ...filters,
          { divider: true },
          { header: 'Static Lists' },
          ...this.emailLists,
        ];
        if (this.hasMoreEmailListsToLoad) {
          filters = [
            ...filters,
            ...[{ isLoadMore: true, disabled: true, callback: this.loadMoreEmailList }],
          ];
        }
      }
      return filters;
    },
    isEmailList() {
      return this.currentFilter.is_email_list;
    },
    hasCustomAudience() {
      return !!this.emailLists.find(list => {
        return list.id === this.currentFilter.id;
      }).fb_user_type_id;
    },
    deleteFilterModalText() {
      const filterType = this.isEmailList ? 'static list' : 'filter';
      return `Are you sure you want to delete this ${filterType}?`;
    },
  },

  methods: {
    ...mapActions({
      removeCondition: 'contactFilters/removeCondition',
      removeGroupCondition: 'contactFilters/removeGroupCondition',
      patchContactFilter: 'contactFilters/patch',
      createContactFilter: 'contactFilters/create',
      deleteContactFilter: 'contactFilters/delete',
      addNewActiveCondition: 'contactFilters/addNewActiveCondition',
      addNewConditionGroup: 'contactFilters/addNewConditionGroup',
      setContactFilterClean: 'contactFilters/clearDirty',
      updateActiveCondition: 'contactFilters/updateActiveCondition',
      updateSearchCondition: 'contactFilters/updateSearchCondition',
      replaceActiveConditions: 'contactFilters/replaceActiveConditions',
      setSelectedContactFilter: 'contactFilters/setSelected',
      clearSelectedContactFilter: 'contactFilters/clearSelected',
      setDisplayOnDashboard: 'contactFilters/setDisplayOnDashboard',
      createEmailList: 'contactsTable/createEmailList',
      findEmailList: 'contactsTable/findEmailLists',
      deleteEmailList: 'contactsTable/deleteEmailList',
      findTeamMembers: 'teamMembers/findTeamMembers',
    }),
    ...mapMutations('contactsTable', [
      'setEmailListId',
      'setIsCustomAudienceCreated',
      'setCreateCustomAudienceFb',
      'setStaticListIdForCustomAudienceFb',
    ]),
    ...mapMutations('contactsExport', [
      'setIsStaticList',
      'setStaticListId',
    ]),

    /**
     * Updates the child condition that has been changed
     *
     * @param  {number} index in the list
     * @param  {opbject} value of the activeFilter
     */
    updateCondition(index, subqueryIndex, value) {
      this.updateActiveCondition({ index, subqueryIndex, activeCondition: value });
    },

    /** Since deprecating condition.type, we now use queryType instead */
    queryType(condition) {
      return condition.queryType || condition.type;
    },

    /**
     * Generates a semi-unique key to use in the v-for.
     *
     * Triggers updates when any of the variables therein are updated.
     *
     * Importantly, does not regenerate a key when the operator or value is changed,
     *  as this typically clears the inputs.
     *
     * If it had, that would re-render the value textfield/datepicker, causing
     * it to lose focus.
     *
     * Also include the number of options from the condition, as this may change
     *  over time as lists are loaded in async.
     *
     * We _do not_ generate a new key based on the value. This would
     * force re-render of the whole line of filters after value change. We do, however,
     * toggle the state of the line between 'empty' and 'full' depending on whether
     * there are conditions or not. This is used for refreshing a cleared row;
     * when cleared, the operator & value are cleared, generating a new key, and
     * refreshing the row.
     *
     * When a reset of the form or a deletion occurs, we increment a counter used to
     * refresh the list. Otherwise, there may be no way to differentiate between
     * some column, and the column being deleted.
     *
     * @param  {number} index     index of array in list.
     * @param  {object} condition condition with full details
     * @return {string}           like `0-created_at-tomorrow`
     */
    generateKey(index, subqueryIndex, condition) {
      const numOptions = condition.options ? condition.options.length : 0;
      const id = this.selectedFilter.id ? this.selectedFilter.id : 0;
      const keyString = `${id}-${index}-${subqueryIndex}-${condition.field}-${condition.operator}-${condition.conditionType}-${numOptions}-${this.resetNumber}-${this.deletions}-${this.groupDeletions}`;
      return keyString;
    },

    generateGroupKey(index, groupConditions) {
      const keyString = `${index}-${groupConditions[0] ? groupConditions[0].groupConditionType : 'AND'}-${this.resetNumber}-${this.groupDeletions}`
      return keyString;
    },

    /**
     * The dropdown with saved filters is changed
     */
    changeSelect(selectedFilter) {
      this.currentFilter = selectedFilter;
      if (selectedFilter.is_email_list) {
        this.showConditions = false;
        this.setEmailListId(selectedFilter.id);
        this.$emit('email-list-selected', selectedFilter.id);
        this.setIsStaticList(true);
        this.setStaticListId(selectedFilter.id);
      } else {
        this.setEmailListId(null);
        this.showConditions = true;
        this.setContactFilterClean();
        this.setSelectedContactFilter(selectedFilter);
        if (!this.selectedFilter.name) {
          this.clearFilters();
        }
        this.populateFilterConditions();
        this.$emit('input', this.activeConditions);
        this.setIsStaticList(false);
      }
    },

    /**
     * Iterate through the selected filter's conditions and populate
     * the activeConditions from them.
     *
     * Also populate the keyword search by sending an event up to the parent.
     */
    populateFilterConditions() {
      this.filterName = this.selectedFilter.name;

      // pull the conditions out and parse them
      let parsedConditions = JSON.parse(this.selectedFilter.conditions);

      // If there's a keywords term, extract it.
      const searchConditionIndex = parsedConditions.findIndex(condition => {
        return this.queryType(condition) === 'keywords';
      });

      if (searchConditionIndex !== -1) {
        const searchCondition = parsedConditions[searchConditionIndex];
        this.$emit('update-external-search-term', searchCondition ? searchCondition.value : '');
      } else {
        this.$emit('update-external-search-term', '');
      }

      if (!Array.isArray(parsedConditions[0])) {
        parsedConditions = [parsedConditions]
      }

      this.activeConditions = parsedConditions.map(conditionGroup => {
        if (Array.isArray(conditionGroup)) {
          return conditionGroup.map((condition, i) => {
            // Set the conditionType to AND_CONDITION if it's not set and it's not the first item
            if (i > 0 && !condition.conditionType) {
              condition.conditionType = AND_CONDITION;
            }
            return { ...condition };
          });
        }

        // Handle the case where conditionGroup is not an array
        return { ...conditionGroup };
      });
    },

    /**
     * Clear the filters completely
     */
    clearFilters() {
      this.resetNumber++;
      this.filterName = defaultFilterName;
      this.activeConditions = [];
      this.currentFilter = {};
      this.showConditions = true;
      this.setEmailListId(null);
      this.clearSelectedContactFilter();
      this.setDisplayOnDashboard(false);
      this.addNewActiveCondition({ index: 0, conditionType: '' });
      this.$emit('update-external-search-term', '');
      this.$emit('input', this.activeConditions);
    },

    clickedSave() {
      if (this.isNew) {
        this.isSavingFirstTime = true; // show modal
        return;
      }

      this.saveFilter();
    },

    /**
     * Save the current filter.
     *
     * Conditions are stripped of the query string & object for saving;
     * Not necessary for the database. Let the front-end handle
     * construction of the query. The back-end should be agnostic.
     *
     * Different service methods are called for create/update
     */
    async saveFilter() {
      // Strip some fields from the activecondition
      let conditions;
      conditions = this.activeConditions.map(condition => {
        return condition.map(
          ({ query, name, icon, secondaryIcon, options, ...restActiveCondition }) =>
            restActiveCondition,
        );
      })

      if (this.selectedFilter && this.selectedFilter.id) {
        await this.patchContactFilter({
          id: this.selectedFilter.id,
          name: this.filterName.trim() || this.selectedFilter.name.trim(),
          conditions: JSON.stringify(conditions),
          display_on_dashboard: this.isDisplayedOnDashboard,
          show_contacts_slipping_away: this.selectedFilter.show_contacts_slipping_away,
          slipping_away_days: this.selectedFilter.slipping_away_days,
        }).catch(error => { }); // store handles error
      } else {
        await this.createContactFilter({
          name: this.filterName.trim(),
          conditions: JSON.stringify(conditions),
          display_on_dashboard: this.isDisplayedOnDashboard,
          show_contacts_slipping_away: this.selectedFilter.show_contacts_slipping_away,
          slipping_away_days: this.selectedFilter.slipping_away_days,
        }).catch(error => { }); // store handles error
      }

      this.isSavingFirstTime = false;
      this.isRenaming = false;
    },

    clickedRenameFilter() {
      this.isRenaming = true;
    },
    applyFilter() {
      this.replaceActiveConditions(this.activeConditions);
    },
    clickedCancelRename() {
      this.filterName = this.selectedFilter.name;
      this.isRenaming = false;
    },
    clickedCancelSave() {
      this.isSavingFirstTime = false;
    },
    clickedCreateStaticListFromFilteredData() {
      this.isRenaming = true;
    },
    clickedSaveAsStaticList() {
      this.isSavingAsStaticList = true;
    },
    clickedCancelStaticListCreation() {
      this.isSavingAsStaticList = false;
    },
    async deleteFilter() {
      if (this.isEmailList) {
        this.deleteEmailList(this.currentFilter.id);
        this.clearFilters();
      } else {
        await this.deleteContactFilter(this.selectedFilter.id).catch(error => { });
      }
      this.isDeleting = false;
      this.clearFilters();
    },

    removeItem(subqueryIndex, groupConditionIndex) {
      this.deletions++;
      this.removeCondition({ groupConditionIndex, subqueryIndex });
    },
    removeGroup(index) {
      this.groupDeletions++;
      this.removeGroupCondition(index)
    },
    async createStaticListWithFilteredContacts() {
      if (this.isStaticListCreated) this.isStaticListCreated = !this.isStaticListCreated;
      await this.createEmailList({
        name: this.staticListName,
        createCustomAudience: this.createCustomAudience,
      });
      this.isSavingAsStaticList = false;
      this.isStaticListCreated = true;
      this.staticListName = '';
      this.findEmailList();
    },
    showCreateCustomAudience() {
      this.setCreateCustomAudienceFb(true);
    },
    getIcon(fbUserTypeId) {
      const icon = fbUserTypeId === 'Personal' ? '$vuetify.icons.facebook' : '$vuetify.icons.liondesk';
      return icon;
    },
    loadMoreEmailList() {
      this.findEmailList(this.emailLists.length);
    },
    loadMoreSavedFilters() {
      this.$emit('load-more-saved-filters-callback');
    },
  },
};
</script>

<style lang="scss" type="text/scss">
.min-width-btn {
  min-width: 0px !important;
}

.background-transparent {
  .v-list__tile--link:hover {
    background: transparent !important;
  }
}

.table-filters {
  hr.divider {
    border: 0;
    border-bottom: 1px solid #eee;
  }

  .saved-filters {
    .v-messages {
      min-height: 0;
    }
  }

  .add-condition {
    margin-left: 26px;
  }

  .add-condition-ff {
    margin-left: 0px;
  }

  .filters-loading {
    margin-bottom: 0;
    height: 7px;
  }

  // Otherwise, too much vertical spacing
  .v-text-field {
    padding-top: 4px;
  }

  .errors {
    color: red;
    padding-left: 10px;
  }

  .v-card__actions {
    .v-progress-circular {
      margin-top: 7px;
    }
  }

  .filter-item {
    transition: background-color 200ms ease-in;

    &:hover {
      background-color: #f8f8f8;
      border-radius: 10px;
    }

    width: 100%;
    overflow: visible;

    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: flex-start;
    justify-content: space-between;

    padding-top: 2px;
    padding-bottom: 2px;

    >.filter__and {
      flex: 0 0 45px;
      text-align: center;
      align-self: flex-start;
      justify-content: center;
      padding-top: 20px;
      color: var(--v-secondary-lighten1);
    }

    >.filter__type {
      display: flex;
      flex: 0 0 250px;
      flex-wrap: nowrap;

      .v-select__selections {
        align-items: center;
        overflow: hidden;
        flex-wrap: nowrap;
        white-space: nowrap;

        .filter-field__name {
          margin: 7px 4px 7px 0;
        }

        // This extraneous input adds padding inside
        // the select clause. Hmph
        input[readonly] {
          display: none;
        }

        span i {
          margin-right: 0.5em;
        }
      }
    }

    // spacing between each condition element:
    >.filter__type,
    .condition .filter__operator,
    .condition .filter__value {
      padding-right: 1em;
    }

    .condition {
      display: flex;
      flex-wrap: nowrap;

      .filter__operator {
        flex: 0 1 262px;
      }

      .filter__value {
        flex: 1 1 100px;
        align-items: flex-start;

        &.short {
          flex: 0 0 100px;
        }

        &.text-field {
          flex: 1 1 320px;
        }
      }

      .v-tooltip {
        flex: 0 0 40px;
        text-align: center;
        margin-top: 12px;
      }
    }

    .v-list__tile__action.delete-condition {
      margin-left: 32px;
      flex: 0 0 32px !important;
      justify-content: center;
      margin-top: 12px;
    }

    // Hides messages for vertical space;
    // no error messages for these fields yet.
    // CAREFUL! You may want these in the future?
    .v-messages {
      display: none;
    }
  }

  .v-select-list {
    .v-list__tile {
      &>i {
        margin-right: 0.5em;
      }
    }
  }
}

.load-more-button {
  pointer-events: auto;
  width: 100%;
}

.condition-group {
  border-style: solid;
  border-color: lightgray;
}

.condition-divider {
  background-color: gray;
}

.condition-group-operator {
  color: gray;
}

.add-condition-button {
  min-width: 88px;
}

.and-or-button {
  font-size: 12px;
  letter-spacing: 0.44px;
  line-height: 16px;
  padding: 0px;
  margin: 0px 0px 0px 0px;
  min-width: 60px;
  background: transparent !important;
}

.and-or-button-second {
  font-size: 12px;
  letter-spacing: 0.44px;
  line-height: 16px;
  padding: 0px;
  min-width: 60px;
  background: transparent !important;
  margin: 3px 0px 0px 0px;
}
</style>
